import React from "react";
import { motion } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";

const getColorFromUsername = (username) => {
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 70%, 50%)`;
};

const UsersOnThisPage = ({ latestTabs, showTime }) => {
  const navigate = useNavigate();
  const { sondageId } = useParams();

  return (
    <>
      {latestTabs
        ?.filter((a) => {
          if (!sondageId) {
            return true;
          }
          return a.latest_sondage_id === sondageId;
        })
        .map((a) => {
          const bounce = true;

          return (
            <motion.div
              key={a.user_name}
              initial={{ scale: 0.9 }}
              animate={bounce ? { scale: [0.9, 1.1, 0.95, 1] } : { scale: 1 }}
              transition={
                bounce
                  ? { duration: 0.6, repeat: Infinity, repeatDelay: 1 }
                  : undefined
              }
              onClick={() =>
                navigate(
                  `/${a.in_project_id}/sondage/${a.latest_sondage_id}/docnbr/0`,
                )
              }
              title={`Opened this page at: ${new Date(a.date).toLocaleString()}`}
              style={{
                minWidth: showTime ? 48 : 32,
                height: showTime ? 42 : 32,
                borderRadius: showTime ? 8 : "50%",
                backgroundColor: getColorFromUsername(a.user_name),
                color: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                marginRight: 8,
                cursor: "pointer",
                fontSize: "0.7rem",
                padding: showTime ? "4px 6px" : 0,
              }}
            >
              <div>{a.user_name.slice(0, 2).toUpperCase()}</div>
              {showTime && (
                <div style={{ fontSize: "0.6rem", fontWeight: "normal" }}>
                  {new Date(a.date).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
              )}
            </motion.div>
          );
        })}
    </>
  );
};

export default UsersOnThisPage;
